import {
  GET_POLICIES_SUMMARY,
  GET_POLICIES_SUMMARY_SUCCESS,
  GET_POLICIES_SUMMARY_FAILURE,
} from './constant';

const initialState = {
  getPoliciesListData: {},
  token: {},
  isError: false,
  error: '',
  loading: false,
};

const policiesReducer = (updatedState, {type, payload}) => {
  const state = updatedState ?? initialState;
  switch (type) {
    case GET_POLICIES_SUMMARY:
      return {
        ...state,
        token: payload.token,
        isError: false,
        loading: true,
      };
    case GET_POLICIES_SUMMARY_SUCCESS:
      return {
        ...state,
        getPoliciesListData: payload,
        isError: false,
        error: '',
        loading: false,
      };
    case GET_POLICIES_SUMMARY_FAILURE:
      return {
        ...state,
        error: payload.error,
        isError: true,
        loading: false,
      };
    default:
      return state;
  }
};
export default policiesReducer;
